import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as screenfull from 'screenfull';
import CtHead from './CtHead/CtHead';
import Dukla from './Dukla/Dukla';
import * as utils from '../../utils';
import * as api from '../../api';
import * as SoundManager from '../../utils/SoundManager';
import * as Features from '../../utils/Features';
import * as Mover from '../../utils/Mover';
import { updateSize, setFullscreen } from '../../redux/actions';
import CompactVideo from './Dukla/SceneCompact/CompactVideo/CompactVideo';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);
    this.handleFullscreen = this.handleFullscreen.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    Features.init();
    api.initHash();

    // init sound
    SoundManager.init();
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);

    // init
    this.handleResize();

    // fullscreen
    if (screenfull.enabled) {
      screenfull.on('change', this.handleFullscreen);
    }

    // init scroll
    setTimeout(() => {
      utils.scrollToTop();
    }, 1500);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    screenfull.off('change', this.handleFullscreen);
  }

  // -------------------------------------------------------
  // Fullscreen
  // -------------------------------------------------------

  handleFullscreen() {
    this.props.setFullscreen(screenfull.isFullscreen);
  }

  // -------------------------------------------------------
  // Resize
  // -------------------------------------------------------

  handleResize() {
    const rW = utils.getWinWidth();
    const rH = utils.getWinHeight();
    Mover.updateSize(rW, rH); // note - not ideal (remove mover and handle everything just by redux state)
    this.props.updateSize(rW, rH);
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { compactVideo } = this.props;
    const compactVideoActive = compactVideo.length > 0;

    return (
      <div id="app" className={compactVideoActive ? 'cropped' : ''}>
        <CtHead />
        <Dukla />
        {compactVideoActive && <CompactVideo videoId={compactVideo} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  compactVideo: state.app.compactVideo,
});

const mapDispatchToProps = dispatch => ({
  updateSize: (width, height) => dispatch(updateSize(width, height)),
  setFullscreen: fsState => dispatch(setFullscreen(fsState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js